export default __webpack_public_path__ + "static/media/explore_category.7aa31382.png";